module.exports = __webpack_public_path__ + "0eb026b3e2d0b180da4fda4342a6d7ce.svg";